export const Arrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="8"
      viewBox="0 0 33 8"
      fill="none"
    >
      <path
        d="M32.3536 4.35355C32.5488 4.15829 32.5488 3.84171 32.3536 3.64645L29.1716 0.464465C28.9763 0.269203 28.6597 0.269203 28.4645 0.464465C28.2692 0.659727 28.2692 0.976309 28.4645 1.17157L31.2929 4L28.4645 6.82843C28.2692 7.02369 28.2692 7.34027 28.4645 7.53553C28.6597 7.73079 28.9763 7.73079 29.1716 7.53553L32.3536 4.35355ZM0 4L2.18557e-08 4.5L32 4.5L32 4L32 3.5L-2.18557e-08 3.5L0 4Z"
        fill="#D9D9D9"
      />
    </svg>
  );
};
